import { Observable, EMPTY } from 'rxjs';
import { switchMap, catchError, first } from 'rxjs/operators';

export function fireAndForget<T>(): (source$: Observable<T>) => Observable<never> {
  return (source$) =>
    source$.pipe(
      first(),
      switchMap(() => EMPTY),
      catchError(() => EMPTY),
    );
}
